/* eslint-disable dot-notation */
import Title from 'components/Title';
import { useMainContext } from 'context/MainContext';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

import { ICommercialProduct } from 'interfaces/ICommercialProduct';
import { IProduct } from 'interfaces/IProduct';
import {
  enumCommercialProductType,
  enumCommercialProductTypeLabel
} from 'enum/enumCommercialProductType';

import { useCommercialProductService } from 'services/commercialProductService';
import { useProductService } from 'services/productService';

import { Container } from './styles';

const AddEditCommercialProduct: React.FC = () => {
  const salechannel = useLocation().state as ICommercialProduct;
  const navigate = useNavigate();
  const { setDialog } = useMainContext();
  const { commercialProductService } = useCommercialProductService();
  const { productService } = useProductService();
  interface IProductResponse {
    Products: IProduct[];
  }
  const [validated, setValidated] = useState(false);
  const [CommercialProductAddEdit, setCommercialProductAddEdit] =
    useState<ICommercialProduct>({
      CommercialProductId: 0,
      CommercialProductUpperId: 0,
      Name: '',
      CommercialProductType: 0,
      ProductId: 0,
      CreatedDate: new Date(),
      DeletedDate: undefined
    } as ICommercialProduct);
  const [products, setProducts] = useState<IProductResponse>();

  const handleConfirm = useCallback(async () => {
    try {
      if (salechannel?.CommercialProductId)
        await commercialProductService.update(CommercialProductAddEdit);
      else await commercialProductService.add(CommercialProductAddEdit);
      navigate(-1);
    } catch (error) {
      console.log(
        `error in AddEditUser - function handleConfirm, error:${error}`
      );
    }
  }, [
    navigate,
    salechannel?.CommercialProductId,
    CommercialProductAddEdit,
    commercialProductService
  ]);

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      event.stopPropagation();

      // Validação manual dos campos
      if (
        CommercialProductAddEdit.Name.trim() === '' ||
        CommercialProductAddEdit.ProductId === 0 ||
        CommercialProductAddEdit.CommercialProductType === 0
      ) {
        setValidated(true);
        return;
      }

      setDialog({ show: true, callBackConfirm: handleConfirm });
    },
    [CommercialProductAddEdit, handleConfirm, setDialog]
  );

  const getData = useCallback(async () => {
    try {
      const productResult = await productService.getAll();
      setProducts(productResult);
    } catch (error) {
      console.log(`error in AddEditUser - function getData, error:${error}`);
    }
  }, [productService]);

  useEffect(() => {
    if (salechannel?.CommercialProductId) {
      setCommercialProductAddEdit(salechannel);
    }
    getData();
  }, [getData, salechannel]);

  return (
    <Container>
      <Title backButton>
        {' '}
        {salechannel?.CommercialProductId ? 'Editar' : 'Adicionar'} Canal de
        Venda{' '}
      </Title>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} sm={12} md={6}>
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Nome"
              defaultValue={CommercialProductAddEdit.Name}
              required
              onChange={e =>
                setCommercialProductAddEdit(prevState => ({
                  ...prevState,
                  Name: e.target.value
                }))
              }
            />
          </Form.Group>
          <Form.Group as={Col} sm={12} md={6}>
            <Form.Label>Produto Financeiro</Form.Label>
            <Form.Select
              name="product"
              required
              value={CommercialProductAddEdit.ProductId}
              onChange={e =>
                setCommercialProductAddEdit(prevState => ({
                  ...prevState,
                  ProductId: Number(e.target.value)
                }))
              }
            >
              <option value="">Selecione um Produto</option>
              {products &&
                products.Products?.sort((a, b) =>
                  a.InternalName.localeCompare(b.InternalName)
                ).map(prod => (
                  <option key={prod.Id} value={prod.Id}>
                    {prod.InternalName}
                  </option>
                ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Campo Obrigatório
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} sm={12} md={6}>
            <Form.Label>Tipo de Produto</Form.Label>
            <Form.Select
              name="commercialProductType"
              required
              value={CommercialProductAddEdit.CommercialProductType}
              onChange={e =>
                setCommercialProductAddEdit(prevState => ({
                  ...prevState,
                  CommercialProductType: Number(e.target.value)
                }))
              }
            >
              <option value="">Selecione um tipo</option>

              {Object.keys(enumCommercialProductType)
                .filter(key => !Number.isNaN(Number(key)))
                .map(key => (
                  <option key={key} value={key}>
                    {enumCommercialProductTypeLabel.get(Number(key))}
                  </option>
                ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Campo Obrigatório
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <hr />
        <Button variant="primary" type="submit">
          Salvar
        </Button>
      </Form>
    </Container>
  );
};

export default AddEditCommercialProduct;
